import React, { Component } from "react";
import { Button, Modal, PageHeader, FormGroup, InputGroup, FormControl, ListGroup, ListGroupItem } from "react-bootstrap";
import { Link, Routes }            from 'react-router-dom'
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome'
import LoaderButton                from "../../components/LoaderButton";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import SortDropdownMembersBasicMenu       from "../../components/utils/SortDropdownMembersBasicMenu";
import RenderLander                from "../../components/utils/RenderLander";
import { handleGoToURL}            from "../../utils/URL";
import uniqueId                    from 'lodash/uniqueId';
import { API, Storage }            from "aws-amplify";
import { Colors }                  from "../../utils/Colors";
import ModalTrainerDetail          from "../../components/modal/ModalTrainerDetail";
import { invokeGetTrainerListAll,
         invokeSetAddClientToTrainerList
       } from "../../utils/AwsInvoke";
import "../../css/trainer/TrainerListAll.css";
import "../../css/form/Btn.css";
import "../../css/modal/ModalBasics.css";
import checkmark_green from '../../images/utils/checkmark_green.png';
import checkmark_gray  from '../../images/utils/checkmark_gray.png';

// uuidv1() = timestamp | uuidv4() = rnadom
const uuidv1 = require('uuid/v1');

export default class TrainerList extends Component {
    constructor(props) {
        super(props);

        var search_term = "&"; // no params for trainers`${this.props.match.params.search_term}`;
        if(search_term === "&") search_term = "";

        this.state = {
              isLoading: true, // default is true
              numberOfRows: 100,
              company_id: "",
              searchMsg: "",
              searchTerm: search_term,
              showLoadingBar:"none",
              showModalTrainerDetail: false,
              sortBy: 1, // default sort by Name Asc
              pageOverlay: "none"
        };
    }

    componentDidMount() {
        this.getMemberList();
    }

    componentDidUpdate(prevProps) {

        var search_term = "&"; //`${this.props.match.params.search_term}`;
        if(search_term === "&") search_term = "";

        if (this.state.searchTerm !== search_term) {
            this.setState({
                searchTerm: search_term
            }, function(){
                this.getMemberList();
            })
        }
    }

    getMemberList = async event => {

        var number_of_rows = this.state.numberOfRows;
        this.setState({
            showLoadingBar: "inline"
        })

        //// If user searched for a member and then hits the back button,
        //// take the user back to the search results page with the search term
        var search_term = this.state.searchTerm;
        var sort_by     = this.state.sortBy;
        var company_id  = this.props.globalCompanyId;

        // SortBy: name ASC, 2: name DESC

        if(search_term != "" && search_term != "&") {
            //this.searchMembers(number_of_rows, sort_by); // search for existing keyword
        } else {
            search_term = "";
        }
        //console.log("Member list company_id: " + company_id);
        const results = await invokeGetTrainerListAll(number_of_rows, sort_by, company_id, search_term.toLowerCase());

        if(results) {
            var logins = results.total_user_logins;
            var tmpt = results.total_members_per_trainer;
            var tppt = results.total_programs_per_trainer;
            var count_arr      = [];
            var user_id_arr    = [];
            var date_login_arr = [];
            var total_members_by_trainer_count_arr  = [];
            var total_members_by_trainer_arr        = [];
            var total_programs_by_trainer_count_arr = [];
            var total_programs_by_trainer_arr       = [];

            for(var key in logins) {
                //console.log("count: " + logins[key].count);
                //console.log("user_id: " + logins[key].user_id);
                count_arr.push(logins[key].count);
                user_id_arr.push(logins[key].user_id);
                date_login_arr.push(logins[key].date_created);
            }

            for(var key in tmpt) {
                total_members_by_trainer_count_arr.push(tmpt[key].count);
                total_members_by_trainer_arr.push(tmpt[key].creator_id);
            }

            for(var key in tppt) {
                /*console.log("-------------");
                console.log("count: " + tppt[key].count);
                console.log("creator_id: " + tppt[key].creator_id);*/
                total_programs_by_trainer_count_arr.push(tppt[key].count);
                total_programs_by_trainer_arr.push(tppt[key].creator_id);
            }

            this.setState({
                members:            results,
                total_count_logins: count_arr, // the number of logins per user
                total_user_logins:  user_id_arr,// all user ids
                total_date_login:   date_login_arr,
                total_members_by_trainer_count: total_members_by_trainer_count_arr,
                total_members_by_trainer: total_members_by_trainer_arr, // all user ids

                total_programs_by_trainer_count: total_programs_by_trainer_count_arr,
                total_programs_by_trainer: total_programs_by_trainer_arr,
                isLoading: false,
                showLoadingBar: "none"
            });
        } else
            this.setState({ isLoading: false, showLoadingBar: "none" })
    }

    clearSearchField = () => {
        // RESET URL
        this.props.history.replace("/client/listAll/&")

        this.setState({
            searchTerm: "", // reset search term if resetting member list
        })
    }

    searchMembers = async () => {
        var search_term = this.state.searchTerm;

        if(this.searchInput != undefined) {
            search_term = this.searchInput.value;

            if(search_term.length === 0) search_term = "&";

            //this.props.history.replace("/client/listAll/"+search_term)

            //// RESET Search Textfield
            if(search_term === "&") {
                this.setState({
                    searchTerm: "", // reset search term if resetting member list
                    searchMsg: ""   // clear search message
                }, function () {
                    this.getMemberList();
                })
                return
            } else {
                this.setState({
                    searchTerm: search_term, // reset search term if resetting member list
                    searchMsg: ""   // clear search message
                }, function () {
                    this.getMemberList();
                })
            }
        } else {

                var company_id     = this.state.company_id;
                var sort_by        = this.state.sortBy;
                var number_of_rows = this.state.numberOfRows;

                const results = await invokeGetTrainerListAll(number_of_rows, sort_by, company_id, search_term.toLowerCase());

                if(results) {
                    this.setState({
                        members: results,
                        searchTerm: search_term,
                        // searchMsg: "You have "+results.search_lgth+ " results when searching for '" + search_term + "'.",
                        isLoading: false,
                        showLoadingBar: "none"
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        showLoadingBar: "none"
                    });
                }
        }
    }

    sortResults = (sort) => {
        this.setState({
            sortBy: sort,
            members: null // reset members object otherwise the members list will re-render multiple times
        }, function(){
            this.getMemberList();
        })
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchMembers();
    }

    async addClientToTrainerList (client_id, client_name, event) {

        if(client_id != "undefined") {
                this.setState({
                    loadingData: "Adding member to list ... ",
                    showLoadingBar: "inline"
                })
                const results = await invokeSetAddClientToTrainerList(client_id);

                if(results) {
                    this.setState({
                        searchMsg: client_name + " added as a member",
                        showLoadingBar: "none"
                    }, function(){
                        this.getMemberList();
                    })

                } else
                    this.setState({
                        showLoadingBar: "none"
                    })
        }
    }

    resetSearch = () =>  {
        this.props.history.replace("/client/listAll/&")

        //// RESET Search Textfield
            this.setState({
                searchTerm: "", // reset search term if resetting member list
                searchMsg: ""   // clear search message
            }, function () {
                this.getMemberList();
            })
    }

    async getAttachment (photo_id) {
        if(photo_id != null) {
            var attachmentURL = await Storage.vault.get(photo_id);
            console.log("attachmentURL: " + attachmentURL);
        }
    }

    renderMembersList(members) {

          var photo_url;
          var search_msg     = "";
          var tmp_search_msg = this.state.searchMsg;
          var reset_btn = <Button className = "btnClientAddNew"
                                  onClick={this.resetSearch.bind()}>
                              Reset Results
                          </Button>

          var search_term = this.state.searchTerm;
          if(search_term === "") reset_btn = "";

          { /*search_msg = <div key={uniqueId()} className="exerciseHeaderButtons"
                            style={{display: "inline-block", width:"100%", border:"1px solid #000"}}>
                            <span className="pull-left"
                                  style={{position:"relative", top:"2px", left:"26px"}}
                                  >
                                  { /*tmp_search_msg* / }
                                  { reset_btn }
                            </span>

                            <span className="pull-right">
                                <SortDropdownMembersBasicMenu sortResults={this.sortResults.bind(this)} />
                            </span>
                       </div>*/ }

            if(members != null) {
                  var logins   = 0;
                  var programs = 0;
                  var clients  = 0;

                  return [{}].concat(members.first_name).map(
                    (member, i) =>
                      i !== 0 ?
                              <div key={uniqueId()}
                                   className="grid exerciseListGrid"
                                   href= {"/client/detail/"+members.id[i-1]}
                                   style={{display: "inline-block", width:"100%"}}
                                   //onClick={(e) => handleGoToURL(e, this, "/client/detail/"+members.id[i-1])}
                                   onClick={(e) => this.showTrainerDetailModal(member + " " + members.last_name[i-1], members.id[i-1], members.email[i-1], members.company_name[i-1], members.company_id[i-1],members.phone[i-1], false)}>
                                        <span className="trainerListRowLeft">
                                                <span className="trainerListSingleRowThumb">
                                                    { member.charAt(0) }
                                                    { /* get profile photo this.getAttachment(members.photo_id[i-1])*/ }
                                                </span>
                                        </span>
                                        <span className="trainerListRowMiddleLeft">
                                                  { member + " " + members.last_name[i-1] }
                                                  { /*}<span className="clientListDateAdded">Created: { (new Date(members.date[i-1])).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) }</span>*/ }
                                        </span>
                                        <span className="trainerListRowMiddleCenter" style={{position:"absolute", top:13, left:290,  width:200}}>
                                            { /*members.email[i-1]*/ }

                                            {
                                                ////  1. Check the member id against the state "total_user_logins" by matching it against the array;
                                                ////  2. If there's a match, get the position element from the array and then get the count number from the count array
                                                logins = this.state.total_count_logins[this.state.total_user_logins.indexOf(members.id[i-1])]
                                            }
                                            { (logins == null ? 0 : "") } logins
                                        </span>
                                        <span className="trainerListRowMiddleCenter" style={{position:"absolute", top:13, left:430,  width:200}}>
                                            { clients = this.state.total_members_by_trainer_count[this.state.total_members_by_trainer.indexOf(members.id[i-1])] }
                                            { (clients == null ? <b style={{color:"red"}}>0</b> : "") }
                                        </span>
                                        <span className="trainerListRowMiddleCenter" style={{position:"absolute", textAlign:"center", top:13, left:505,  width:50}}>
                                            { programs = this.state.total_programs_by_trainer_count[this.state.total_programs_by_trainer.indexOf(members.id[i-1])] }
                                            { (programs == null ? <b style={{color:"red"}}>0</b> : "") }
                                        </span>
                                        <span className="trainerListRowRight">
                                                { members.email[i-1] /*members.company_name[i-1]*/ }
                                                { /*}<span className="clientListEditCol">
                                                            { members.member[i-1] === "match" ? <span className="glyphicon glyphicon-user glyphiconAddClientBtn" style={{right:"-7px", color:"#ccc", fontSize:"30px"}}/> : <span className="glyphicon glyphicon-plus-sign glyphiconAddClientBtn" style={{color: Colors.add_button_bg}} onClick={this.addClientToTrainerList.bind(this, members.id[i-1], member + " " + members.last_name[i-1])} />  }
                                                </span>
                                                { /*}<span   className="clientListEditCol"
                                                        href= {"/client/edit/"+members.id[i-1]}
                                                        onClick={(e) => handleGoToURL(e, this, "/client/detail/"+members.id[i-1])}
                                                        Edit
                                                </span>
                                                <span className="clientListDeleteCol pullRight"
                                                      onClick={(e) => this.handleDeleteMember(e, members.id[i-1], member + " " + members.last_name[i-1])}>
                                                    <span className="glyphicon glyphicon-remove-circle glyphiconDeleteClientBtn" style={{color: Colors.delete_button_bg }} />
                                                </span>*/ }
                                        </span>
                            </div>

                            :
                            <span key={uniqueId()} style={{position:"relative", top:0, left:0 }}>
                                {<div className="exerciseHeaderSearchBa" style={{height: 60, width:"100%", border:"1px solid #ccc", borderBottom: 0}}>
                                    <span>
                                        {/*<FormGroup>
                                           <InputGroup>
                                             <FormControl key = {uniqueId()}
                                                          type="text"
                                                          placeholder=""
                                                          defaultValue={this.state.searchTerm}
                                                          inputRef={ref => { this.searchInput = ref; }}
                                                          onKeyPress={this.handleKeyPress}
                                                      />

                                               <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                                     onClick={() => this.clearSearchField()}
                                               />
                                               <InputGroup.Button>
                                                 <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }} onClick={() => this.searchMembers()}>Search</Button>
                                               </InputGroup.Button>
                                           </InputGroup>
                                       </FormGroup>*/ }
                                        <span className="trainerListRowMiddleLeft" style={{position:"relative", top:17, left:80,  }}>Trainer Name</span>
                                        <span className="trainerListRowMiddleCenter" style={{position:"absolute", top:20, left:284, width: 200}}>Last 7 Days</span>
                                        <span className="trainerListRowMiddleCenter" style={{position:"absolute", textAlign:"center", top:11, left:334, width: 200}}>Total<br/>Clients</span>
                                        <span className="trainerListRowMiddleCenter" style={{position:"absolute", textAlign:"center", top:11, left:430, width: 200}}>Total<br/>Programs</span>
                                      </span>
                                  </div> }
                                  { search_msg }

                                  { i === 0 && members.search_lgth < 1 ?
                                        <ListGroupItem className="exerciseListGrid" style={{height:400}}>
                                            <br/>
                                        You currently have 0 trainers.
                                        </ListGroupItem>

                                    : null }
                          </span>
                  );
             }
    }

    //// Temp solution for mobile browser back button issue described above;
    //// works great but having issues with the popup confirm box
    /*handleNewDeleteMember = event => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }*/

    getNext100Results = () => {
        var tmp_rows = this.state.numberOfRows;
        tmp_rows = tmp_rows + 100;

        this.setState({
            numberOfRows: tmp_rows
        }, function(){
            this.getMemberList();
        })
    }

    resetTrainerList = () => {
        this.getMemberList();
    }

    showTrainerDetailModal = (member_name, member_id, member_email, company_name, company_id, phone, show_trainer_form) => {
        var location_abbrev;
        console.log("company_id: " + company_id);

        if(company_id == "001877c0-ebf1-11e9-a945-d5dded95ac71") {
            location_abbrev = "hayes";
            company_name = "P4L Training - Hayes Valley"
        } else if(company_id == "c84934b0-ebf0-11e9-911a-fbdac363f28e") {
            location_abbrev = "fidi";
            company_name = "P4L Training - FiDi";
        } else if(company_id == "4b07edc0-ebf0-11e9-85dd-9b2fcf560e30") {
            location_abbrev = "castro";
            company_name = "P4L Training - Market/Castro";
        }
        console.log("company_name: " + location_abbrev);


        this.setState({
            trainerPhoneNum: phone,
            clientId: member_id,
            trainerName: member_name,
            trainerEmail: member_email,
            trainerCompanyId: company_id,
            trainerCompanyName: company_name,
            trainerLocationAbbrev: location_abbrev,
            showTrainerForm: show_trainer_form,
            showModalTrainerDetail: true
        })
    }

    renderPrograms() {
        var next_100;

        //if(!this.state.isLoading)
        //    next_100 = <span style={{display:"inline-block", width:"100%", textAlign:"center", fontSize:"18px", cursor:"pointer"}} onClick={() => this.getNext100Results()}>Next 100 results >></span>

        if(this.state.searchMsg != "") next_100 = ""; // if user is searching for a member, hide "next 100 results" msg

        return (
              <div className="programs" style={{display: "inline-block", width:"100%", border:"0px solid #000"}}>
                <PageHeader>
                        <span style={{width:"220px", position:"relative", top:6}}>
                            {/*}<span className="glyphicon glyphicon-user" style={{ position:"relative", top:2, fontSize: '.9em', color: Colors.primary_color, paddingRight:"16px" }}/>*/ }
                            Trainers
                        </span>
                        <span className="pull-right" style={{ position:"relative", top: -3, right: 12}}>
                            <Button className = "btnClientAddNew"
                                    style     = {{ position:"relative", top:0}}
                                    //onClick   = {(e) => handleGoToURL(e, this, "/client/new")}
                                    onClick   = {(e) => this.showTrainerDetailModal("", "", "", "", "", true)}>
                                Add New Trainer
                            </Button>
                        </span>
                </PageHeader>

                <ListGroup style={{display: "inline-block", width:"100%", border:"0px solid #000"}}>
                    {!this.state.isLoading && this.renderMembersList(this.state.members)}
                </ListGroup>
                    { next_100 }
                <br/><br/><br/><br/>
              </div>
        );
    }

    render() {
        let closeModalAddReminder = () => this.setState({ showModalTrainerDetail: false }); //close simple modal window

        return (
              <div className="ProgramList">
                { this.renderPrograms() }
                {this.state.showModalTrainerDetail ?
                    <ModalTrainerDetail
                        show                  = {this.state.showModalTrainerDetail}
                        trainerName           = {this.state.trainerName}
                        trainerId             = {this.state.clientId}
                        trainerPhoneNum       = {this.state.trainerPhoneNum}
                        trainerEmail          = {this.state.trainerEmail}
                        trainerCompanyId      = {this.state.trainerCompanyId}
                        trainerCompanyName    = {this.state.trainerCompanyName}
                        showTrainerForm       = {this.state.showTrainerForm}
                        resetTrainerList      = {this.resetTrainerList}
                        trainerLocationAbbrev = {this.state.trainerLocationAbbrev}
                        onHide={closeModalAddReminder}
                    />
                : null}
                <FooterLoadingBar text={"Retrieving Members ..."}
                                  showLoadingBar={this.state.showLoadingBar}/>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/trainer/TrainerList.js